import React from 'react'

import { usePresenceSubscription } from 'conversations/hooks/usePresence'
import { getEndUserPresence } from 'conversations/modules/endUser/selectors'
import { useSelector } from 'react-redux'
import { EndUser } from 'shared/typings/endUser/EndUser'
import { Availability } from 'shared/typings/user/Availability'
import { UserWithAvailability } from 'shared/typings/user/UserLite'

import { OnlineIndicatorWithBorder } from '@driftt/conversation-components'
import { Avatar as TideAvatar, AvatarProps } from '@driftt/tide-core'

import { RootState } from 'typesafe-actions'

import styles from './styles.module.css'

export const Avatar: React.FC<AvatarProps> = ({ ...rest }) => {
  return <TideAvatar {...rest} forcePlaceholder={!rest.user || rest.forcePlaceholder} />
}

interface AvatarWithAvailableAwayProps extends AvatarProps {
  user?: UserWithAvailability
}

interface AvatarWithOnlineIndicatorProps extends AvatarProps {
  user?: EndUser
}

export const AvatarWithAvailableAway: React.FC<AvatarWithAvailableAwayProps> = ({
  user,
  ...rest
}): JSX.Element => {
  return (
    <Avatar
      user={user}
      withPresence={true}
      presenceState={user?.availability === Availability.AVAILABLE ? 'available' : 'away'}
      {...rest}
    />
  )
}

export const AvatarWithOnlineIndicator: React.FC<AvatarWithOnlineIndicatorProps> = ({
  user,
  ...rest
}): JSX.Element => {
  usePresenceSubscription(user)
  const isOnline = useSelector<RootState, boolean>(getEndUserPresence(user?.id))

  return (
    <div className={styles.avatarWithPresence}>
      <Avatar user={user} {...rest} />
      <OnlineIndicatorWithBorder online={isOnline} />
    </div>
  )
}
